var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEpbPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 460 460",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1038_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1215_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1943_",
    style: {
      fill: "#DE3E30"
    },
    d: "M281.682,214.742H178.318c-11.874,0-21.5-9.626-21.5-21.5v-62.909h146.364v62.909 C303.182,205.116,293.556,214.742,281.682,214.742z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2096_",
    style: {
      opacity: 0.49,
      fill: "#D0D5D9"
    },
    d: "M281.802,130.333v42.656c0,12.302-9.973,22.275-22.275,22.275 H157.713c-0.238,0-0.469-0.028-0.706-0.036c1.363,10.996,10.721,19.513,22.086,19.513h101.814c12.302,0,22.275-9.973,22.275-22.275 v-62.134H281.802z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1213_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_459_",
    style: {
      fill: "#F9B65F"
    },
    d: "M259.292,130.333v-26.864c0-16.177-13.114-29.292-29.292-29.292 s-29.292,13.114-29.292,29.292v26.864h-22.981V99.94c0-28.869,23.403-52.273,52.273-52.273s52.273,23.403,52.273,52.273v30.394 H259.292z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1212_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3073_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M230,190.452c-4.292,0-7.77-3.479-7.77-7.77v-20.909 c0-4.291,3.478-7.77,7.77-7.77s7.77,3.479,7.77,7.77v20.909C237.77,186.973,234.292,190.452,230,190.452z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2831_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1942_",
    style: {
      fill: "#86C867"
    },
    d: "M35.743,265.969C16.003,265.969,0,281.972,0,301.713v74.877 c0,19.74,16.003,35.743,35.743,35.743h313.401V265.969H35.743z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1017_",
    style: {
      opacity: 0.49,
      fill: "#D0D5D9"
    },
    d: "M48.176,391.283c-19.74,0-35.743-16.003-35.743-35.743v-74.877 c0-2.242,0.216-4.432,0.611-6.559C5.079,280.658,0,290.592,0,301.713v74.877c0,19.74,16.003,35.743,35.743,35.743h313.401v-21.05 H48.176z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2832_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1941_",
    style: {
      fill: "#6AAC4B"
    },
    d: "M424.257,265.969h-75.113v146.364h75.113c19.74,0,35.743-16.003,35.743-35.743 v-74.877C460,281.972,443.997,265.969,424.257,265.969z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2095_",
    style: {
      opacity: 0.49,
      fill: "#D0D5D9"
    },
    d: "M424.257,391.283h-75.113v21.05h75.113 c19.74,0,35.743-16.003,35.743-35.743v-21.05C460,375.28,443.997,391.283,424.257,391.283z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1087_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3072_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M390.35,373.058c-1.989,0-3.977-0.758-5.495-2.276 c-3.034-3.034-3.034-7.954,0-10.989l20.643-20.642l-20.643-20.642c-3.034-3.034-3.034-7.954,0-10.989 c3.035-3.034,7.954-3.034,10.99,0l26.137,26.137c1.457,1.457,2.275,3.433,2.275,5.494s-0.818,4.037-2.275,5.494l-26.137,26.136 C394.327,372.299,392.338,373.058,390.35,373.058z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1088_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1940_",
    style: {
      fill: "#ECF0F1"
    },
    cx: 64.572,
    cy: 339.151,
    r: 20.294
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1090_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1939_",
    style: {
      fill: "#ECF0F1"
    },
    cx: 125.455,
    cy: 339.151,
    r: 20.294
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1091_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1938_",
    style: {
      fill: "#ECF0F1"
    },
    cx: 186.337,
    cy: 339.151,
    r: 20.294
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1092_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3071_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M271.818,346.921h-31.363c-4.292,0-7.77-3.479-7.77-7.77s3.478-7.77,7.77-7.77 h31.363c4.292,0,7.77,3.479,7.77,7.77S276.11,346.921,271.818,346.921z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpbPin);
export default __webpack_public_path__ + "static/media/epbPin.d291540fd612ef7206e000647d094a7e.svg";
export { ForwardRef as ReactComponent };